import { IProps } from 'component/Calendar/DateCeil';
import ScheduleProvider from './Provider/ScheduleProvider';
import ContainerView from './components/ContainerView';

const MeetingSchedule: React.FC<IProps> = () => {
  return (
    <ScheduleProvider>
      <ContainerView />
    </ScheduleProvider>
  );
};

export default MeetingSchedule;
